import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Subscription } from 'rxjs';
import { FirebaseService } from '../../../../../service/firebase.service';
import { SharedService } from '../../../../../services/shared.service';



export interface KidData {
  name: string,
  userName?: string,
  parentID?: string,
  action?: string,
  timestamp?: Date,
  signatureURL?: string,
  type?: string

}

@Component({
  selector: 'app-ordermalta',
  templateUrl: './ordermalta.component.html',
  styleUrls: ['./ordermalta.component.scss']
})
export class OrdermaltaComponent implements OnInit {

  constructor(private db: AngularFirestore, private _firebase: FirebaseService, private _sharedVar: SharedService) { }
  docs: KidData[];
  docsub: Subscription;
  diplayedColumns = ['date', 'kidName', 'userName', 'action', 'signature'];

  kidsDatas: any[] = [];
  ngOnInit(): void {

    this.db.collection('data').ref.where(
      'mainUserID', '==', this._firebase.user.uid
    ).get().then(
      (snapshot) => {
        this.kidsDatas = snapshot.docs.map(doc =>
          doc.data()


        )

        this.kidsDatas.forEach(item => {
          item.timestamp = new Date(item.timestamp.seconds * 1000 + item.timestamp.nanoseconds / 1000000)
        })


        this.kidsDatas.sort((a, b) => {
          if (a.timestamp > b.timestamp)
            return -1;
          else
            return 1;
        })


      })
  }

}
